export default __webpack_public_path__ + "static/media/Office-Shifting.02370dfc.png";